import { render, staticRenderFns } from "./matching-list-interests-mutual.vue?vue&type=template&id=711b6e9c&scoped=true&"
import script from "./matching-list-interests-mutual.vue?vue&type=script&lang=ts&"
export * from "./matching-list-interests-mutual.vue?vue&type=script&lang=ts&"
import style0 from "./matching-list-interests-mutual.vue?vue&type=style&index=0&id=711b6e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711b6e9c",
  null
  
)

export default component.exports